import { RootState } from 'app/reducer';
import {
  PartialSearchingProps,
  PaginationParams,
  SearchParams,
  SortParams
} from 'modules/Shared/type';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { Pagination } from 'modules/Layout/component/Pagination/pagination';
import {
  setHealthCheckHelpListParamsAction,
  SetHealthCheckHelpListParamsAction
} from 'modules/PlantDiseases/action/list';

export interface StateProps {
  pagination: PaginationParams;
  filter: SearchParams;
  sort: SortParams;
  currentCount: number;
  totalPages: number;
}

export interface DispatchProps {
  setParams: (
    payload: PartialSearchingProps
  ) => SetHealthCheckHelpListParamsAction;
}

export type Props = StateProps & DispatchProps;

export const mapState = (state: RootState): StateProps => {
  const { pagination, filter, sort, healthCheckHelp, totalPages } =
    state.plantDiseases.list;

  return {
    pagination,
    filter,
    sort,
    currentCount: healthCheckHelp.length,
    totalPages
  };
};

export const mapDispatch = (dispatch: Dispatch): DispatchProps => ({
  setParams: (payload: PartialSearchingProps) =>
    dispatch(setHealthCheckHelpListParamsAction(payload))
});

export default connect<StateProps, DispatchProps>(
  mapState,
  mapDispatch
)(Pagination);
